module.exports = __webpack_public_path__ + "img/bg.0fc2db77.png";